import React from 'react';
import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import HowItWorks from '../components/home/HowItWorks';
import CaseStudies from '../components/home/CaseStudies';
import Industries from '../components/home/Industries';
import Testimonials from '../components/home/Testimonials';
import FAQ from '../components/home/FAQ';
import ContactForm from '../components/home/ContactForm';

const HomePage = () => {
    return (
        <>
            <Hero />
            <Features />
            <HowItWorks />
            <Industries />
            <FAQ />
            <ContactForm />
        </>
    );
};

export default HomePage;